import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import {
  PortInfoState,
  PortInfoParams,
  PortInfoApiResponse,
} from "./PortInfoType";
import { RootState } from "../../redux/store";
import { GetTime } from "../../utils/timeget";

//情報取得API連携
export const fetchAsyncPortInfo: any = createAsyncThunk<
  PortInfoParams,
  PortInfoApiResponse
>("portInfo/get", async () => {
  const response = await axiosSettings.get("api-admin/port");
  return response.data;
});

export const fetchAsyncPortCreate: any = createAsyncThunk<
  PortInfoParams,
  PortInfoApiResponse
>("CreatePort/post", async (formData: any) => {
  const response = await axiosSettings.post(
    "api-admin/port",
    formData
  );
  return response.data;
});

const initialState: PortInfoState = {
  portStatus: null,
  updatedTime: "",
  loading: false,
  error: "",
  createdPort: null,
};

const PortInfoSlice = createSlice({
  name: "PortInfo",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAsyncPortInfo.fulfilled, (state, action) => {
      //トークン認証&通信成功、データを受け取る
      if (action.payload.status === "Success") {
        state.portStatus = action.payload.data.result;
        state.updatedTime = GetTime();
        state.error = "";
      } else {
        state.error = action.payload.data.result;
      }
      state.loading = false;
    });
    builder.addCase(fetchAsyncPortInfo.pending, (state, action) => {
      state.loading = true;
    });
    //ポート発行
    builder.addCase(fetchAsyncPortCreate.fulfilled, (state, action) => {
      if (action.payload.status === "Success") {
        state.createdPort = action.payload.data.result[0];
      }
    });
  },
});

export const PortInfoStatus = (state: RootState) => state.PortInfo.portStatus;
export const PortInfoError = (state: RootState) => state.PortInfo.error;
export const PortInfoLoading = (state: RootState) => state.PortInfo.loading;
export const PortInfoUpdatedTime = (state: RootState) =>
  state.PortInfo.updatedTime;
export default PortInfoSlice.reducer;
